import { render, staticRenderFns } from "./MarginLeft.vue?vue&type=template&id=040f069b&scoped=true&"
import script from "./MarginLeft.vue?vue&type=script&lang=js&"
export * from "./MarginLeft.vue?vue&type=script&lang=js&"
import style0 from "./MarginLeft.vue?vue&type=style&index=0&id=040f069b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f069b",
  null
  
)

export default component.exports